import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import {
  ApplicationId,
  DeleteObject as DeleteObjectModel,
  PostDataBody,
  PostDataSuccess as PostDataSuccessModel,
  DeleteObjectSuccess as DeleteObjectSuccessModel,
  PutDataBody,
  PutDataSuccess as PutDataSuccessModel,
  ConditionalGroup,
} from '../_models/ignatius.models';
import {
  ApplicationData as ApplicationDataModel,
  DropdownId,
  Dropdown as DropdownModel,
  ConditionalQuery as ConditionalQueryModel,
} from '../_models/ignatius.models';
import { Error } from '../_models/auth.models';

/**
 * Ignatius action types
 */
export enum IgnatiusActionTypes {
  QUERY_REPORT = '[Ignatius] Query Report',
  QUERY_REPORT_SUCCESS = '[Ignatius] Query Report Success',
  QUERY_REPORT_FAILED = '[Ignatius] Query Report Failed',
  APPLICATION_DATA = '[Ignatius] Application Data',
  APPLICATION_DATA_SUCCESS = '[Ignatius] Application Data Success',
  APPLICATION_DATA_FAILED = '[Ignatius] Application Data Failed',
  RESET = '[Ignatius] RESET',
  DROPDOWN = '[Ignatius] Dropdown',
  DROPDOWN_SUCCESS = '[Ignatius] Dropdown Success',
  DROPDOWN_FAILED = '[Ignatius] Dropdown Failed',
  POST_DATA = '[Ignatius] Post Data',
  POST_DATA_SUCCESS = '[Ignatius] Post Data Success',
  POST_DATA_FAILED = '[Ignatius] Post Data Failed',
  DELETE_OBJECT = '[Ignatius] Delete Object',
  DELETE_OBJECT_SUCCESS = '[Ignatius] Delete Object Success',
  DELETE_OBJECT_FAILED = '[Ignatius] Delete Object Failed',
  PUT_DATA = '[Ignatius] Put Data',
  PUT_DATA_SUCCESS = '[Ignatius] Put Data Success',
  PUT_DATA_FAILED = '[Ignatius] Put Data Failed',
  CONDITIONAL_QUERY = '[Ignatius] Conditional Query',
  CONDITIONAL_QUERY_SUCCESS = '[Ignatius] Conditional Query Success',
  CONDITIONAL_QUERY_FAILED = '[Ignatius] Conditional Query Failed',
}

/**
 * Operations
 */
export class QueryReport implements Action {
  readonly type = IgnatiusActionTypes.QUERY_REPORT;

  constructor(public applicationTableId: number) {}
}

export class QueryReportSuccess implements Action {
  readonly type = IgnatiusActionTypes.QUERY_REPORT_SUCCESS;

  constructor(public applicationTableId: number, public payload: Array<any>) {}
}

export class QueryReportFailed implements Action {
  readonly type = IgnatiusActionTypes.QUERY_REPORT_FAILED;

  constructor(public payload: Error) {}
}

export class ApplicationData implements Action {
  readonly type = IgnatiusActionTypes.APPLICATION_DATA;

  constructor(public payload: ApplicationId) {}
}

export class ApplicationDataSuccess implements Action {
  readonly type = IgnatiusActionTypes.APPLICATION_DATA_SUCCESS;

  constructor(public payload: ApplicationDataModel) {}
}

export class ApplicationDataFailed implements Action {
  readonly type = IgnatiusActionTypes.APPLICATION_DATA_FAILED;

  constructor(public payload: Error) {}
}

export class Reset implements Action {
  readonly type = IgnatiusActionTypes.RESET;

  constructor() {}
}

export class Dropdown implements Action {
  readonly type = IgnatiusActionTypes.DROPDOWN;

  constructor(public fieldId: string) {}
}

export class DropdownSuccess implements Action {
  readonly type = IgnatiusActionTypes.DROPDOWN_SUCCESS;

  constructor(
    public fieldId: string,
    public payload: Array<DropdownModel>
  ) {}
}

export class DropdownFailed implements Action {
  readonly type = IgnatiusActionTypes.DROPDOWN_FAILED;

  constructor(public payload: Error) {}
}

export class PostData extends Reference implements Action {
  readonly type = IgnatiusActionTypes.POST_DATA;

  constructor(public applicationTableId: number, public payload: PostDataBody) {
    super();
  }
}

export class PostDataSuccess extends Reference implements Action {
  readonly type = IgnatiusActionTypes.POST_DATA_SUCCESS;

  constructor(
    public applicationTableId: number,
    public payload: PostDataSuccessModel
  ) {
    super();
  }
}

export class PostDataFailed extends Reference implements Action {
  readonly type = IgnatiusActionTypes.POST_DATA_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class DeleteObject implements Action {
  readonly type = IgnatiusActionTypes.DELETE_OBJECT;

  constructor(public payload: DeleteObjectModel) {}
}

export class DeleteObjectSuccess implements Action {
  readonly type = IgnatiusActionTypes.DELETE_OBJECT_SUCCESS;

  constructor(
    public applicationTableId: string,
    public payload: DeleteObjectSuccessModel
  ) {}
}

export class DeleteObjectFailed implements Action {
  readonly type = IgnatiusActionTypes.DELETE_OBJECT_FAILED;

  constructor(public payload: Error) {}
}

export class PutData extends Reference implements Action {
  readonly type = IgnatiusActionTypes.PUT_DATA;

  constructor(
    public recordId: number,
    public applicationTableId: string,
    public payload: PutDataBody
  ) {
    super();
  }
}

export class PutDataSuccess extends Reference implements Action {
  readonly type = IgnatiusActionTypes.PUT_DATA_SUCCESS;

  constructor(
    public recordId: number,
    public applicationTableId: string,
    public payload: PutDataSuccessModel
  ) {
    super();
  }
}

export class PutDataFailed extends Reference implements Action {
  readonly type = IgnatiusActionTypes.PUT_DATA_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class ConditionalQuery implements Action {
  readonly type = IgnatiusActionTypes.CONDITIONAL_QUERY;

  constructor(
    public applicationTableId: number,
    public conditions: Array<ConditionalGroup>
  ) {}
}

export class ConditionalQuerySuccess implements Action {
  readonly type = IgnatiusActionTypes.CONDITIONAL_QUERY_SUCCESS;

  constructor(public applicationTableId: number, public payload: Array<any>) {}
}

export class ConditionalQueryFailed implements Action {
  readonly type = IgnatiusActionTypes.CONDITIONAL_QUERY_FAILED;

  constructor(public payload: Error) {}
}

/**
 * Available types
 */
export type Actions =
  | QueryReport
  | QueryReportSuccess
  | QueryReportFailed
  | ApplicationData
  | ApplicationDataSuccess
  | ApplicationDataFailed
  | Reset
  | Dropdown
  | DropdownSuccess
  | DropdownFailed
  | PostData
  | PostDataSuccess
  | PostDataFailed
  | DeleteObject
  | DeleteObjectSuccess
  | DeleteObjectFailed
  | PutData
  | PutDataSuccess
  | PutDataFailed
  | ConditionalQuery
  | ConditionalQuerySuccess
  | ConditionalQueryFailed;
